"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTABLE_VIEW_ASOCIADOS_COLUMNS_MAP = void 0;
exports.SORTABLE_VIEW_ASOCIADOS_COLUMNS_MAP = {
    id: 'smsout_id',
    origen: 'smsout_sender',
    destino: 'smsout_receiver',
    envio_a_plataforma: 'smsout_clienteenvio',
    envio_a_telco: 'smsout_senttime',
    recibido_destino: 'smsout_receivedtime',
    mensaje: 'smsout_msg',
    cantidad_sms: 'smsout_multipart',
    estado: 'smsout_status',
    respuesta: 'recibidos',
};
